import { Feature } from "geojson";
import {
  addDistanceToFeatures,
  FeatureWithDistance,
} from "./addDistanceToFeatures";

export const sortFeaturesByDistance = (
  startPoint: [number, number],
  features: Feature[],
): FeatureWithDistance[] => {
  const featuresWithDistance = addDistanceToFeatures(startPoint, features);

  return featuresWithDistance.sort((a, b) => {
    if (a.distance && b.distance) return a.distance - b.distance;
    else return 0;
  });
};
